import { Box, Text } from '@quintoandar-tokko/jopijs';
import styles from './pendingEventCard.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '../../../Dashboard.trans.json';

function EventTime({ timeRange = '', first = false, isNow = false }) {
  return (
    <Box className={styles.eventTimeContainer}>
      <Text className={styles.eventTime}>{timeRange}</Text>
      {first && (
        <Text className={styles.nextEventTag}>
          {isNow
            ? Trans(translations, 'Now')
            : Trans(translations, 'NextEvent')}
        </Text>
      )}
    </Box>
  );
}

export default EventTime;
